import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  initLoyaltyData,
  createLoyalty,
  editLoyalty,
  resetLoyalty,
  deactivateLoyalty,
  reactivateLoyalty,
} from 'actions/customers/loyalty';
import { loadLoyaltySubscription } from 'actions/customers/loyalty/loyaltySubscription';
import { push } from 'react-router-redux';
import { askConfirmAction } from 'actions/confirm-action';
import * as clevertapCustomersLoyalty from 'clevertap/customers/loyalty';
import ConfirmActionModal from 'components/ConfirmActionModal';
import FeatureBlockerPage from 'components/FeatureBlockerPage';
import Landing from './Landing';
import Subscribe from './Subscribe';
import Reset from './Reset';
import Edit from './Edit';
import Existing from './Existing';
import Create from './Create';
import Introduction from './Introduction';
import styles from './Loyalty.css';
import MenuTitleLoyalty from './Components/MenuTitleLoyalty';

class Loyalty extends Component {
  constructor(props) {
    super(props);
    const views = {
      introduction: 'introduction',
      create: 'create',
      exist: 'exist',
      edit: 'edit',
      reset: 'reset',
      subscribe: 'subscribe',
      landing: 'landing',
    };
    this.state = {
      views,
      currentView: null,
      showSuccessfulModal: false,
    };
  }

  componentDidMount() {
    const { billingNotification } = this.props;
    this.props.loadLoyaltySubscription(billingNotification);
    if (this.props.loyalty.hasLoyalty === null) {
      this.props.initLoyaltyData();
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      loyalty: { hasLoyalty },
      loyaltySubscription: { subscriptionDetail },
    } = nextProps;
    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];
    const hasActiveSubscription =
      (detailBasic && detailBasic.is_active) ||
      (detailPro && detailPro.is_active);
    const { currentView, views } = this.state;

    if (hasLoyalty === null || _.isEmpty(subscriptionDetail)) {
      return;
    }
    if (
      currentView === views.subscribe ||
      currentView === views.create ||
      currentView === views.edit ||
      currentView === views.reset
    ) {
      return;
    }

    if (hasLoyalty) {
      if (hasActiveSubscription) {
        this.setState({ currentView: views.exist });
      } else {
        this.setState({ currentView: views.introduction });
      }
    } else if (hasActiveSubscription) {
      this.setState({ currentView: views.landing });
    } else {
      this.setState({ currentView: views.introduction });
    }
  }

  render() {
    const {
      user,
      loyalty,
      loyaltySubscription,
      trialEndAt,
      outletSlot,
      alreadySubscribed,
      isOwner,
    } = this.props;
    if (
      loyalty.hasLoyalty === null ||
      loyaltySubscription.pageOnLoading ||
      _.isEmpty(loyaltySubscription.subscriptionDetail)
    ) {
      return null;
    }

    const { currentView, views } = this.state;

    return (
      <div>
        {currentView !== views.exist &&
          currentView !== views.landing &&
          currentView !== views.subscribe && (
            <div className={`row ${styles['menu-title-loyalty-row']}`}>
              <MenuTitleLoyalty
                menuTitle="Loyalty Program"
                loyaltySubscription={loyaltySubscription}
                goToSubscribeView={this._showSubscribe}
              />
            </div>
          )}
        <div id="loyalty-content" className={`${styles.wrapper} col-md-12`}>
          {!user.is_owner && !loyalty.hasLoyalty ? (
            <FeatureBlockerPage />
          ) : (
            <div className={`${styles['loyalty-container']}`}>
              {currentView === views.introduction && (
                <Introduction goToSubscribeView={this._showSubscribe} />
              )}
              {currentView === views.landing && (
                <Landing
                  loyaltySubscription={loyaltySubscription}
                  goToSubscribeView={this._showSubscribe}
                  goToCreateView={this._showCreate}
                />
              )}
              {currentView === views.subscribe && (
                <Subscribe
                  loyaltySubscription={loyaltySubscription}
                  trialEndAt={trialEndAt}
                  outletSlot={outletSlot}
                  alreadySubscribed={alreadySubscribed}
                  isOwner={isOwner}
                  onClickCancel={this._refreshViewOnCancel}
                  afterSubscribe={this._refreshView}
                  goToSubscribeView={this._showSubscribe}
                />
              )}
              {currentView === views.create && (
                <Create
                  loyaltySubscription={loyaltySubscription}
                  createLoyalty={this._createLoyalty}
                  askConfirmAction={this._askConfirmAction}
                  nextAction={this.props.nextAction}
                  refreshView={this._refreshView}
                />
              )}
              {currentView === views.exist && (
                <Existing
                  {...this.props.loyalty}
                  loyaltySubscription={loyaltySubscription}
                  goToSubscribeView={this._showSubscribe}
                  showSuccessModal={this.state.showSuccessfulModal}
                  closeSuccessModal={this._closeSuccessfulModal}
                  showEdit={this._showEdit}
                  showReset={this._showReset}
                  reactivateLoyalty={this.props.reactivateLoyalty}
                  deactivateLoyalty={this.props.deactivateLoyalty}
                />
              )}
              {currentView === views.edit && (
                <Edit
                  {...this.props.loyalty}
                  loyaltySubscription={loyaltySubscription}
                  editLoyalty={this._editLoyalty}
                  askConfirmAction={this._askConfirmAction}
                  nextAction={this.props.nextAction}
                  refreshView={this._refreshView}
                />
              )}
              {currentView === views.reset && (
                <Reset
                  {...this.props.loyalty}
                  loyaltySubscription={loyaltySubscription}
                  resetLoyalty={this._resetLoyalty}
                  askConfirmAction={this._askConfirmAction}
                  nextAction={this.props.nextAction}
                  refreshView={this._refreshView}
                />
              )}
            </div>
          )}
          <ConfirmActionModal />
        </div>
      </div>
    );
  }

  _askConfirmAction = location => {
    this.props.askConfirmAction(push(location));
  };

  _createLoyalty = data => {
    this.props.createLoyalty(data);
    this.setState({ showSuccessfulModal: true });
  };

  _resetLoyalty = data => {
    this.props.resetLoyalty(data);
    this.setState({
      currentView: this.state.views.exist,
    });
    clevertapCustomersLoyalty.resetLoyalty(data);
  };

  _editLoyalty = data => {
    this.props.editLoyalty(data);
    this.setState({
      currentView: this.state.views.exist,
    });
    clevertapCustomersLoyalty.editLoyalty(data);
  };

  _showCreate = () => {
    this.setState({
      currentView: this.state.views.create,
    });
  };

  _refreshView = () => {
    const {
      loyalty: { hasLoyalty },
      loyaltySubscription: { subscriptionDetail },
    } = this.props;
    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];
    const hasActiveSubscription =
      (detailBasic && detailBasic.is_active) ||
      (detailPro && detailPro.is_active);

    if (hasLoyalty) {
      if (hasActiveSubscription) {
        this.setState({ currentView: this.state.views.exist });
      } else {
        this.state.currentView === 'subscribe'
          ? this.setState({ currentView: this.state.views.create })
          : this.setState({ currentView: this.state.views.introduction });
      }
    } else if (hasActiveSubscription) {
      this.setState({ currentView: this.state.views.landing });
    } else {
      this.state.currentView === 'subscribe'
        ? this.setState({ currentView: this.state.views.create })
        : this.setState({ currentView: this.state.views.introduction });
    }
  };

  _refreshViewOnCancel = () => {
    const {
      loyalty: { hasLoyalty },
      loyaltySubscription: { subscriptionDetail },
    } = this.props;
    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];
    const hasActiveSubscription =
      (detailBasic && detailBasic.is_active) ||
      (detailPro && detailPro.is_active);

    if (hasLoyalty) {
      if (hasActiveSubscription) {
        this.setState({ currentView: this.state.views.exist });
      } else {
        this.setState({ currentView: this.state.views.introduction });
      }
    } else if (hasActiveSubscription) {
      this.setState({ currentView: this.state.views.landing });
    } else {
      this.setState({ currentView: this.state.views.introduction });
    }
  };

  _showEdit = () => {
    this.setState({
      currentView: this.state.views.edit,
    });
  };

  _showReset = () => {
    this.setState({
      currentView: this.state.views.reset,
    });
  };

  _closeSuccessfulModal = () => {
    this.setState({ showSuccessfulModal: false });
  };

  _showSubscribe = () => {
    this.setState({
      currentView: this.state.views.subscribe,
    });
  };

  _showLanding = () => {
    this.setState({
      currentView: this.state.views.landing,
    });
  };
}

function mapStateToProps(state) {
  const {
    already_subscribed,
    business: { trial_end_at, outlet_slot },
    is_owner,
  } = state.moka.user;
  const {
    customers: { loyalty, loyaltySubscription },
    moka: { user },
    confirmAction: { nextAction },
    billingNotification,
  } = state;

  return {
    alreadySubscribed: already_subscribed,
    trialEndAt: trial_end_at,
    outletSlot: outlet_slot,
    isOwner: is_owner,
    billingNotification,

    loyalty,
    loyaltySubscription,
    user,
    nextAction,
  };
}

export default connect(
  mapStateToProps,
  {
    initLoyaltyData,
    createLoyalty,
    editLoyalty,
    resetLoyalty,
    deactivateLoyalty,
    reactivateLoyalty,
    askConfirmAction,
    loadLoyaltySubscription,
  }
)(Loyalty);
